import { defineMessages } from 'react-intl';

const fiberMessages = defineMessages({
    fixTitle: {
        id: 'fiber-damaged-fix-title',
        defaultMessage: 'Are you sure you want to fix the fiber?',
    },
    markDamagedTitle: {
        id: 'fiber-damaged-confirm-title',
        defaultMessage: 'Are you sure you want to mark the fiber as damaged?',
    },
    cancelMarkDamaged: {
        id: 'fiber-damaged-cancel',
        defaultMessage: 'Cancel',
    },
    confirmMarkDamaged: {
        id: 'fiber-damaged-confirm',
        defaultMessage: 'Confirm',
    },
});

export default fiberMessages;
